import React, { useEffect, useState, useContext } from 'react'
import { graphql } from 'gatsby'
import loadable from '@loadable/component'
import Layout from 'components/layout'
import SEO from 'components/seo'

import Hero from 'sections/Home/Hero'
import HowItWorks from 'sections/Home/HowItWorks'
import RecentSuccess from 'sections/Home/RecentSuccess'
import Press from 'sections/Home/Press'

const Marquee = loadable(() => import('sections/Home/Marquee'))
const Contact = loadable(() => import('sections/Home/Contact'))
const Partners = loadable(() => import('sections/Home/Partners'))
const HowItWorksMobile = loadable(
  () => import('sections/Home/HowItWorksMobile')
)
const EnvironmentsMobile = loadable(
  () => import('sections/Home/EnvironmentsMobile')
)
const IndexPage = ({ data }) => {
  const [desktop, setDesktop] = useState(true)

  useEffect(() => {
    setDesktop(window.innerWidth > 1200)
    window.addEventListener('resize', () => {
      setDesktop(window.innerWidth > 1200)
    })
    return () => {
      window.removeEventListener('resize', () => {})
    }
  }, [])
  return (
    <Layout>
      <SEO title="Home" />
      <Hero data={data} />

      {desktop ? (
        <>
          <HowItWorks />
        </>
      ) : (
        <>
          <HowItWorksMobile />
        </>
      )}
      <Marquee />
      <RecentSuccess data={data} />
      <Partners />
      <Press />
      <Contact page="home" />
    </Layout>
  )
}

export const fluidImage = graphql`
  fragment fluidImage on File {
    childImageSharp {
      fluid(maxWidth: 1680, quality: 100) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }
`
export const hugeImage = graphql`
  fragment hugeImage on File {
    childImageSharp {
      fluid(maxWidth: 5000, quality: 100) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }
`
export const mobileImage = graphql`
  fragment mobileImage on File {
    childImageSharp {
      fluid(maxWidth: 768, quality: 100) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }
`
export const smallImage = graphql`
  fragment smallImage on File {
    childImageSharp {
      fluid(maxWidth: 400, quality: 100) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }
`
export const criticalImage = graphql`
  fragment criticalImage on File {
    childImageSharp {
      fluid(maxWidth: 1200, quality: 75) {
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
`
export const pageQuery = graphql`
  query {
    heroPlaceholder: file(relativePath: { eq: "introBG.jpg" }) {
      ...fluidImage
    }
    heroMobile: file(relativePath: { eq: "hero-still.webp" }) {
      ...criticalImage
    }
    robotGallery: file(relativePath: { eq: "robotGallery.jpg" }) {
      ...hugeImage
    }
    oldWay: file(relativePath: { eq: "oldWay.jpg" }) {
      ...fluidImage
    }
    newWay: file(relativePath: { eq: "newWay.jpg" }) {
      ...fluidImage
    }
    oldWayMobile: file(relativePath: { eq: "oldMobile.jpg" }) {
      ...fluidImage
    }
    newWayMobile: file(relativePath: { eq: "newMobile.jpg" }) {
      ...fluidImage
    }
    structured: file(relativePath: { eq: "structured.jpg" }) {
      ...fluidImage
    }
    unstructured: file(relativePath: { eq: "unstructured.jpg" }) {
      ...fluidImage
    }
    collab: file(relativePath: { eq: "collab.jpg" }) {
      ...fluidImage
    }
    structuredMobile: file(relativePath: { eq: "structuredMobile.jpg" }) {
      ...mobileImage
    }
    unstructuredMobile: file(relativePath: { eq: "unstructuredMobile.jpg" }) {
      ...mobileImage
    }
    collabMobile: file(relativePath: { eq: "collabMobile.jpg" }) {
      ...mobileImage
    }
    boxes: file(relativePath: { eq: "boxes.png" }) {
      ...smallImage
    }
    pcb: file(relativePath: { eq: "pcb.png" }) {
      ...smallImage
    }
    car: file(relativePath: { eq: "car.png" }) {
      ...smallImage
    }
    controller: file(relativePath: { eq: "controller.jpg" }) {
      ...fluidImage
    }
    software: file(relativePath: { eq: "software.jpg" }) {
      ...fluidImage
    }
    rapidSense: file(relativePath: { eq: "rapidSense.jpg" }) {
      ...fluidImage
    }
    productsCollab: file(relativePath: { eq: "productsCollab.jpg" }) {
      ...fluidImage
    }
    pickAndPlace: file(relativePath: { eq: "pickAndPlace.jpg" }) {
      ...smallImage
    }
    packaging: file(relativePath: { eq: "packaging.jpg" }) {
      ...smallImage
    }
    palletizing: file(relativePath: { eq: "palletizing.jpg" }) {
      ...smallImage
    }
    assembly: file(relativePath: { eq: "assembly.jpg" }) {
      ...smallImage
    }
    inspection: file(relativePath: { eq: "inspection.jpg" }) {
      ...smallImage
    }
    binPicking: file(relativePath: { eq: "binPicking.jpg" }) {
      ...smallImage
    }
    fastening: file(relativePath: { eq: "fastening.jpg" }) {
      ...smallImage
    }
    welding: file(relativePath: { eq: "welding.jpg" }) {
      ...smallImage
    }
    machineTending: file(relativePath: { eq: "machineTending.jpg" }) {
      ...smallImage
    }
    schaeffler: file(relativePath: { eq: "schaeffler.webp" }) {
      ...smallImage
    }
    BMW: file(relativePath: { eq: "BMW.webp" }) {
      ...smallImage
    }
    valiant: file(relativePath: { eq: "valiant.webp" }) {
      ...smallImage
    }
    kawasaki: file(relativePath: { eq: "kawasaki.webp" }) {
      ...smallImage
    }
    hella: file(relativePath: { eq: "hella.webp" }) {
      ...smallImage
    }
    siemensSuccess: file(relativePath: { eq: "siemensSuccess.webp" }) {
      ...smallImage
    }
    yaskawa: file(relativePath: { eq: "yaskawa.webp" }) {
      ...smallImage
    }
    dematic: file(relativePath: { eq: "dematic.webp" }) {
      ...smallImage
    }
  }
`

export default IndexPage
